import React from 'react';
import {Navigate, Route, Routes, useParams} from 'react-router-dom';

import {ACCOUNT_TABS} from 'src/constants';
import {useAdminAccessRight} from 'src/hooks/access-rights';
import {BasicLicenseTabStructure} from 'src/modules/profile/account/tabs/license-and-features/basic-tab-scructure';

import Loading from '@pb/kit-component-loading';

import {AccountConnectorLimitsTab} from './connector-limits-tab';
import {LICENSE_AND_FEATURES_SUB_TABS} from './constants';
import {NoLicensePage} from './no-license-page/no-license-page';

type Props = {
    accountId: number,
};

type CatchAllProps = Props & {
    isConnectorLimitsAllowed: boolean,
};

const NoLicenseCatchAll = ({accountId, isConnectorLimitsAllowed}: CatchAllProps) => {
    const params = useParams<{'*': string}>();
    const remainingPath = params['*'] ?? '';

    if (/^\d+/.test(remainingPath)) {
        return <Loading fast={true}/>;
    }

    if (!isConnectorLimitsAllowed) {
        return <NoLicensePage accountId={accountId}/>;
    }

    return (
        <Navigate
            to={`/profile/account/${accountId}/${ACCOUNT_TABS.LICENSE.name}/${LICENSE_AND_FEATURES_SUB_TABS.CONNECTOR_LIMITS.name}`}
            replace={true}
        />
    );
};

export const NoLicenseFeaturesTabView = ({accountId}: Props) => {
    const {canViewAccountConnectorLimits} = useAdminAccessRight();
    const isConnectorLimitsAllowed = canViewAccountConnectorLimits(accountId);

    return (
        <Routes>
            {isConnectorLimitsAllowed ? (
                <Route
                    path={`/${LICENSE_AND_FEATURES_SUB_TABS.CONNECTOR_LIMITS.name}`}
                    element={(
                        <BasicLicenseTabStructure
                            noLicense={true}
                            main={<AccountConnectorLimitsTab accountId={accountId}/>}
                            accountId={accountId}
                            activeSubTab={LICENSE_AND_FEATURES_SUB_TABS.CONNECTOR_LIMITS.name}
                        />
                    )}
                />
            ) : null}
            <Route
                path="*"
                element={<NoLicenseCatchAll accountId={accountId} isConnectorLimitsAllowed={isConnectorLimitsAllowed}/>}
            />
        </Routes>
    );
};
